import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import { useSeo } from "@/hooks/useSeo";
import { submitHighlights, submitNotes } from "@/mocks/submit";
import SubmitForm from "./components/SubmitForm";

export default function SubmitPage() {
  useSeo({
    title: "匿名投稿 | 隐私保护与保密机制的安全爆料通道 - 爆料51",
    description:
      "进入爆料51匿名投稿通道：无需注册、不强制实名，采用隐私保护与保密机制处理每一条安全爆料。正文限 500 字，可自愿留下匿名回执代号接收反馈。",
    keywords: "匿名投稿,安全爆料,爆料51匿名通道,隐私保护,保密机制",
    path: "/submit",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://cwxxkj.cn/" },
          { "@type": "ListItem", position: 2, name: "匿名投稿", item: "https://cwxxkj.cn/submit" },
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "匿名投稿 | 隐私保护与保密机制的安全爆料通道 - 爆料51",
        url: "https://cwxxkj.cn/submit",
        description: "无需注册、不强制实名的匿名投稿与安全爆料通道。",
        inLanguage: "zh-CN",
      },
    ],
  });

  return (
    <SiteLayout>
      <PageHero
        eyebrow="Secure Submission"
        title="匿名投稿通道：只带走事实，不带走身份"
        subtitle="填写下面这张表单即可完成投稿，不需要账号、不需要实名。所有字段中只有信息类型、概括与经过是必填项，其余都可以留空。"
        crumbs={[{ label: "首页", to: "/" }, { label: "匿名投稿" }]}
      />

      <section className="bg-background-100 py-12 md:py-16">
        <div className="w-full px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {submitHighlights.map((item) => (
              <div
                key={item.label}
                className="flex items-center gap-4 bg-background-50 border border-background-200 rounded-lg px-5 py-4"
              >
                <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <div>
                  <p className="font-heading font-semibold text-sm text-foreground-950">{item.label}</p>
                  <p className="mt-0.5 text-xs text-foreground-600">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 pb-16 md:pb-24">
        <div className="w-full px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
            <div className="lg:col-span-7">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-6">
                填写投稿信息
              </h2>
              <SubmitForm />
            </div>

            <aside id="notes" className="lg:col-span-5">
              <div className="lg:sticky lg:top-28 space-y-5">
                <div className="bg-primary-950 rounded-lg p-6 md:p-7">
                  <div className="flex items-center gap-3 mb-5">
                    <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                      <i className="ri-shield-check-line text-xl" aria-hidden="true"></i>
                    </span>
                    <h2 className="font-heading font-semibold text-lg text-background-50">投稿须知</h2>
                  </div>
                  <ul className="space-y-4">
                    {submitNotes.map((note) => (
                      <li key={note} className="flex items-start gap-3 text-sm leading-relaxed text-background-200">
                        <i className="ri-check-double-line text-accent-400 mt-0.5" aria-hidden="true"></i>
                        {note}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-background-50 border border-background-200 rounded-lg p-6">
                  <h3 className="font-heading font-semibold text-base text-foreground-950 mb-3 flex items-center gap-2">
                    <i className="ri-lock-password-line text-primary-600" aria-hidden="true"></i>
                    提交之后会发生什么
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600">
                    信息进入通道后会先做脱敏处理，再按涉密程度分级流转。我们不会在公开渠道展示可定位到个人的原始材料，也不会把内容用于任何商业用途。
                  </p>
                </div>

                <div className="bg-accent-100 border border-accent-200 rounded-lg p-6">
                  <h3 className="font-heading font-semibold text-base text-accent-900 mb-3 flex items-center gap-2">
                    <i className="ri-alert-line" aria-hidden="true"></i>
                    如果你感到不确定
                  </h3>
                  <p className="text-sm leading-relaxed text-accent-900/90">
                    先不要提交，可以浏览爆料指南中的自我保护清单，确认自己的操作环境与内容都没有留下可回溯的线索。
                  </p>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}